import React from 'react';
import { Icon, Header, Menu } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const Tile = ({ title, icon, iconSize, to, t, onClick, id, component }) => (
  <Menu.Item className="tile" onClick={onClick} style={{ cursor: 'pointer' }}>
    {icon && <Icon name={icon} size={iconSize} className="tileIcon" />}
    <Header id={id} className="tileHeader">
      {t(title)}
    </Header>
    {component && <div className="tileComponent">{component}</div>}
  </Menu.Item>
);

Tile.defaultProps = {
  onClick: () => {},
  iconSize: 'huge'
};

export default withTranslation()(Tile);
